// Application constants

export const SITE_URL =
  process.env.REACT_APP_SITE_URL || 'https://app.codevnext.shop';

export const SHOPIFY_STORE_URL = 'https://codevnext.shop/';
export const SHOPIFY_MYSHOPIFY_URL = 'https://codevnext.myshopify.com';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api';

// Formspree (opcional): si está definido, el formulario usa Formspree en lugar del servidor local
export const CONTACT_FORM_ENDPOINT = process.env.REACT_APP_CONTACT_FORM_ID
  ? `https://formspree.io/f/${process.env.REACT_APP_CONTACT_FORM_ID}`
  : null;

// Backend con Nodemailer: POST a esta URL para enviar al email configurado en el servidor (.env)
export const CONTACT_API_URL = `${API_BASE_URL.replace(/\/$/, '')}/contact`;

export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  SERVICES: '/services',
  CONTACT: '/contact',
  BLOG: '/blog',
  PORTFOLIO: '/portfolio'
};

export const BREAKPOINTS = {
  SM: '576px',
  MD: '768px',
  LG: '992px',
  XL: '1200px'
};

export const ANIMATION_DURATION = {
  FAST: '0.2s',
  NORMAL: '0.3s',
  SLOW: '0.5s'
};

export const Z_INDEX = {
  DROPDOWN: 1000,
  STICKY: 1020,
  FIXED: 1030,
  MODAL_BACKDROP: 1040,
  MODAL: 1050,
  POPOVER: 1060,
  TOOLTIP: 1070
};
